import { Cache } from "@zyzgroup/core-common";
import zh from "./locales/zh-cn";
import en from "./locales/en";

// global loaded locale
export const Ls = new Cache<any>();

// global locale
let L = "zh-cn";
// Ls.set(L, zh);

useLocale(en);
useLocale(zh);

export function useLocale(
  preset?: string | { name: string },
  object?: { name: string }
): Promise<{ name: string }> {
  if (!preset) {
    // get current locale
    return Ls.get(L);
  }
  let l;
  if (typeof preset === "string") {
    const presetLower = preset.toLowerCase();
    if (Ls.get(presetLower)) {
      /// 已加载
      l = presetLower;
    } else if (object) {
      /// 覆盖
      Ls.set(presetLower, object);
      l = presetLower;
    } else {
      /// 未加载
      // return useLocale(await import(`./locales/${preset}`));
      return Ls.get(L);
    }
  } else {
    /// 按需加载语言文件
    const { name } = preset;
    Ls.set(name, preset);
    l = name;
  }
  if (l) {
    L = l;
  }
  return Ls.get(l) || Ls.get(L);
}
